import React from 'react';
import './_homeCard.scss';
import { Row, Col } from 'reactstrap';
import Card from './_homeCard'

import './_homeCardList.scss';

export default (props) => {
    const { cardsData } = props;
    const { educators } = cardsData;
    const { learn } = cardsData;
    const { getInvolved } = cardsData;

    return (
        <Row className="justify-content-center mb-5">
            <Col xs="12" md="6" lg="4" className="my-2 align-self-center">
                <Card title={educators.title} subtitle={educators.subtitle} image={props.images.educators} slug={educators.slug} />
            </Col>
            <Col xs="12" md="6" lg="4" className="my-2 align-self-center">
                <Card title={learn.title} subtitle={learn.subtitle} image={props.images.learn} slug={learn.slug} />
            </Col>
            <Col xs="12" md="6" lg="4" className="my-2 align-self-center">
                <Card title={getInvolved.title} subtitle={getInvolved.subtitle} image={props.images.getInvolved} slug={getInvolved.slug} />
            </Col>
        </Row>
    )
}



// WEBPACK FOOTER //
// ./src/pages/index/_homeCardList.js